import * as Yup from "yup";
import { COMPANY_BASE_PROPERTIES } from "../../../../api/constants";
import {campaignDateValidation} from "./sharedValidationConfig";

export const indexExchangeConfig = {
    ...COMPANY_BASE_PROPERTIES,
    /**
     * User Readable name of company the user is onBoarding with
     */
    companyText: "Onboarding With Index Exchange",

    /**
     * lowercase no spaces or underscores name of company
     * This will be passed to the activate model and
     * used when saving to create the correct submission url
     */
    company: "indexexchange",

    /**
     * HTML that explains how to use the form
     */
    instructions:
        "You have selected a platform that automatically reports usage for targeting. You will be billed for data usage by the platform unless the segment is applied for suppression purposes. Suppression segments are billed by Semcasting directly based on the discounted deployed record formula. Activating this audience means you agree to this billing method.",

    /**
     * data used to create a company activation block
     */
    companyBlockOptions: {
        val: "indexexchange",
        text: "Index Exchange",
        img: "indexexchange-logo.svg",
    },

    /**
     * anchor tag used to login to a specific platform
     */
    loginLink:
        '<a href="https://app.indexexchange.com/#/login?returnUrl=%2Faccounts-page" target="_blank">Log in to Index Exchange</a>',

    layout: [
        // {
        //     fieldType: "checkboxGroup",
        //     labelText: "Devices to Activate",
        //     fieldName: "device_type",
        //     required: false,
        //     checkboxes: [
        //         {
        //             labelText: "OpenX ID",
        //             fieldName: "CLIENT_ID",
        //             value: "CLIENT_ID",
        //             checked: true,
        //             disabled: false,
        //         },
        //         {
        //             labelText: "Hashed Emails",
        //             fieldName: "hashed_emails",
        //             value: "hashed_emails_sha256",
        //             checked: true,
        //             disabled: false,
        //         },
        //     ],
        // },
        // {
        //     fieldType: "radioGroup",
        //     labelText: "Mobile Devices",
        //     fieldName: "mobile_devices",
        //     required: true,
        //     radioButtons: [
        //         {
        //             labelText: "Top Devices",
        //             fieldName: "top_devices",
        //             value: "top_ios_android",
        //             checked: true,
        //         },
        //         {
        //             labelText: "All Devices",
        //             fieldName: "all_devices",
        //             value: "ios_android",
        //             checked: false,
        //         },
        //         {
        //             labelText: "No Devices",
        //             fieldName: "no_devices",
        //             value: "no_devices",
        //             checked: false,
        //         },
        //     ],
        // },
        {
            fieldType: "checkboxGroup",
            labelText: "IP Addresses",
            fieldName: "device_type",
            required: true,
            checkboxes: [
                {
                    labelText: "Web Network / WiFi",
                    fieldName: "web_network_wifi",
                    value: "web_network_wifi",
                    checked: true,
                    disabled: true,
                },
            ],
        },
        {
            fieldType: "textField",
            fieldName: "audience_name",
            labelText: "Audience Name",
            required: true,
        },
        {
            fieldType: "textField",
            fieldName: "deal_name",
            labelText: "Deal Name",
            required: true,
        },
        {
            fieldType:'selectPickerG',
            fieldName:'demand_partners',
            labelText:'Demand Partners',
            defaultOption:'Select Product',
            options:[
                {
                    text: "Adform - RTB",
                    val: "adform_rtb"
                },
                {
                    text: "AdTheorent - RTB",
                    val: "adtheorent_rtb"
                },
                {
                    text: "Adobe Advertising Cloud - RTB",
                    val: "adobe_advertising_cloud_rtb"
                },
                {
                    text: "Advanced Store - RTB",
                    val: "advanced_store_rtb"
                },
                {
                    text: "Amazon DSP - RTB",
                    val: "amazon_dsp_rtb"
                },
                {
                    text: "Appier - RTB",
                    val: "appier_rtb"
                },
                {
                    text: "Azira - Formerly Near - RTB",
                    val: "azira_formerly_near_rtb"
                },
                {
                    text: "Azira - LLC - RTB",
                    val: "azira_llc_rtb"
                },
                {
                    text: "Basis DSP - RTB",
                    val: "basis_dsp_rtb"
                },
                {
                    text: "Beeswax - RTB",
                    val: "beeswax_rtb"
                },
                {
                    text: "Bidswitch - RTB",
                    val: "bidswitch_rtb"
                },
                {
                    text: "BidTheatre AB - RTB",
                    val: "bidtheatre_ab_rtb"
                },
                {
                    text: "Bidease - RTB",
                    val: "bidease_rtb"
                },
                {
                    text: "Bidmachine - RTB",
                    val: "bidmachine_rtb"
                },
                {
                    text: "Bidtellect - RTB",
                    val: "bidtellect_rtb"
                },
                {
                    text: "Blis - RTB",
                    val: "blis_rtb"
                },
                {
                    text: "Bypass - RTB",
                    val: "bypass_rtb"
                },
                {
                    text: "Cadent - RTB",
                    val: "cadent_rtb"
                },
                {
                    text: "Carta DSP - RTB",
                    val: "carta_dsp_rtb"
                },
                {
                    text: "Clearpier - RTB",
                    val: "clearpier_rtb"
                },
                {
                    text: "ClueP - RTB",
                    val: "cluep_rtb"
                },
                {
                    text: "Cognitiv - RTB",
                    val: "cognitiv_rtb"
                },
                {
                    text: "Crimtan - RTB",
                    val: "crimtan_rtb"
                },
                {
                    text: "DV360 - RTB",
                    val: "dv360_rtb"
                },
                {
                    text: "Decide Co - RTB",
                    val: "decide_co_rtb"
                },
                {
                    text: "Deep Intent - RTB",
                    val: "deep_intent_rtb"
                },
                {
                    text: "Delta - RTB",
                    val: "delta_rtb"
                },
                {
                    text: "DemandBase - RTB",
                    val: "demandbase_rtb"
                },
                {
                    text: "Dynadmic - RTB",
                    val: "dynadmic_rtb"
                },
                {
                    text: "Dynalyst - RTB",
                    val: "dynalyst_rtb"
                },
                {
                    text: "EQ Works - RTB",
                    val: "eq_works_rtb"
                },
                {
                    text: "Edge226 - RTB",
                    val: "edge226_rtb"
                },
                {
                    text: "Eskimi DSP - RTB",
                    val: "eskimi_dsp_rtb"
                },
                {
                    text: "GroundTruth - RTB",
                    val: "groundtruth_rtb"
                },
                {
                    text: "Hawk - RTB",
                    val: "hawk_rtb"
                },
                {
                    text: "IQM - RTB",
                    val: "iqm_rtb"
                },
                {
                    text: "Illumin - RTB",
                    val: "illumin_rtb"
                },
                {
                    text: "InMarket - RTB",
                    val: "inmarket_rtb"
                },
                {
                    text: "Infillion - RTB",
                    val: "infillion_rtb"
                },
                {
                    text: "Jamloop - RTB",
                    val: "jamloop_rtb"
                },
                {
                    text: "Knorex - RTB",
                    val: "knorex_rtb"
                },
                {
                    text: "Leanback Digital - RTB",
                    val: "leanback_digital_rtb"
                },
                {
                    text: "Loblaw - RTB",
                    val: "loblaw_rtb"
                },
                {
                    text: "LoopMe - RTB",
                    val: "loopme_rtb"
                },
                {
                    text: "Lucead - RTB",
                    val: "lucead_rtb"
                },
                {
                    text: "MadHive - RTB",
                    val: "madhive_rtb"
                },
                {
                    text: "Media Smart - RTB",
                    val: "mediasmart_rtb"
                },
                {
                    text: "MediaGo - RTB",
                    val: "mediago_rtb"
                },
                {
                    text: "Moloco - RTB",
                    val: "moloco_rtb"
                },
                {
                    text: "Moloco mWeb - RTB",
                    val: "moloco_mweb_rtb"
                },
                {
                    text: "Nativo - RTB",
                    val: "nativo_rtb"
                },
                {
                    text: "NextRoll - RTB",
                    val: "nextroll_rtb"
                },
                {
                    text: "NextRoll - PAAPI - RTB",
                    val: "nextroll_pappi_rtb"
                },
                {
                    text: "Nexxen - RTB",
                    val: "nexxen_rtb"
                },
                {
                    text: "Octillion - RTB",
                    val: "octillion_rtb"
                },
                {
                    text: "OpenAds - RTB",
                    val: "openads_rtb"
                },
                {
                    text: "Opera - RTB",
                    val: "opera_rtb"
                },
                {
                    text: "Optable - RTB",
                    val: "optable_rtb"
                },
                {
                    text: "Pelmorex - RTB",
                    val: "pelmorex_rtb"
                },
                {
                    text: "Pontiac Intelligence - RTB",
                    val: "pontiac_intelligence_rtb"
                },
                {
                    text: "PulsePoint - RTB",
                    val: "pulsepoint_rtb"
                },
                {
                    text: "Quantcast - RTB",
                    val: "quantcast_rtb"
                },
                {
                    text: "Remerge - RTB",
                    val: "remerge_rtb"
                },
                {
                    text: "Reset Digital - RTB",
                    val: "reset_digital_rtb"
                },
                {
                    text: "Sabio Holdings DSP - RTB",
                    val: "sabio_holdings_dsp_rtb"
                },
                {
                    text: "Samsung DSP - RTB",
                    val: "samsung_dsp_rtb"
                },
                {
                    text: "Simpli.fi - RTB",
                    val: "simpli_fi_rtb"
                },
                {
                    text: "Smaato DSP - RTB",
                    val: "smaato_dsp_rtb"
                },
                {
                    text: "Sqreem - RTB",
                    val: "sqreem_rtb"
                },
                {
                    text: "StackAdapt - RTB",
                    val: "stackadapt_rtb"
                },
                {
                    text: "Start.io - RTB",
                    val: "start_io_rtb"
                },
                {
                    text: "TEMU - RTB",
                    val: "temu_rtb"
                },
                {
                    text: "Tangoo SRL - RTB",
                    val: "tangoo_srl_rtb"
                },
                {
                    text: "Temu AMS - RTB",
                    val: "temu_ams_rtb"
                },
                {
                    text: "Temu Video - RTB",
                    val: "temu_video_rtb"
                },
                {
                    text: "The Trade Desk - RTB",
                    val: "the_trade_desk_rtb"
                },
                {
                    text: "Unity - RTB",
                    val: "unity_rtb"
                },
                {
                    text: "VDX.tv - RTB",
                    val: "vdx_tv_rtb"
                },
                {
                    text: "Viant - RTB",
                    val: "viant_rtb"
                },
                {
                    text: "Vibe.co - RTB",
                    val: "vibe_co_rtb"
                },
                {
                    text: "Wpartner DSP - RTB",
                    val: "wpartner_dsp_rtb"
                },
                {
                    text: "Xandr - RTB",
                    val: "xandr_rtb"
                },
                {
                    text: "Yahoo DSP - RTB",
                    val: "yahoo_dsp_rtb"
                },
                {
                    text: "Zemanta - RTB",
                    val: "zemanta_rtb"
                },
                {
                    text: "zMaticoo - RTB",
                    val: "zematicoo_rtb"
                }
            ],
            required: true
        },
        {
            fieldType: "textField",
            fieldName: "buyer_id",
            labelText: "Demand Partner Buyer ID",
            required: true,
        },
        // {
        //     fieldType: "textField",
        //     fieldName: "advertiser_id",
        //     labelText: "Advertiser ID",
        //     required: true,
        // },
        // {
        //     fieldType: "textField",
        //     fieldName: "account_id",
        //     labelText: "Account ID",
        //     required: true,
        // },
        {
            fieldType: "dateRange",
            fieldName: "campaign_range",
            labelText: "Campaign Date Range",
            required: "dateRangeRequired",
        },
        {
            fieldType: "radioGroup",
            labelText: "Planned Usage of this Segment:",
            fieldName: "audience_usage",
            required: true,
            radioButtons: [
                {
                    labelText: "Targeting",
                    fieldName: "use_type_inclusion",
                    value: "I",
                    checked: false,
                },
                {
                    labelText: "Suppression",
                    fieldName: "use_type_exclusion",
                    value: "X",
                    checked: false,
                },
            ],
        },
        {
            fieldType: "selectPickerTag",
            fieldName: "creativeTagIdDropDown",
            labelText: "Creative Tag ID",
            url: "/v2/secure/attributor/creative-tags",
            placeholder: "Select a New or existing Tag for your creative",
            namePropName: "creativeTagId",
            textPropName: "creativeTagId",
            valuePropName: "creativeTagId",
            required: true,
        },
        {
            fieldType: "creativeTagId",
            fieldName: "creativeTagId",
            labelText: "Creative Tag ID",
            required: true,
        },
        {
            fieldType: "creativeTag",
            fieldName: "creativeTag",
            labelText: "Creative Tag",
            required: true,
        },
        {
            fieldType: "pricing",
        },
    ],

    /**
     * an array of property names that can be saved and repeatedly used to "Activate/OnBoard" with a specific company
     */
    savableDataNames: [],

    formik: {
        initialValues: {
            device_type: ["web_network_wifi"],
            campaign_range_start: "",
            campaign_range_end: "",
            audience_usage: "",
            creativeTagIdDropDown: "",
            creativeTagId:"",
            audience_name:"",
            deal_name:"",
            demand_partners: "",
            buyer_id: ""
        },
        // We used Yup here for data validation and condition.
        validationSchema: Yup.object().shape({
            audience_name: Yup.string().required("Audience Name is required").max(515, "Audience Name should not exceed 515 characters"),
            deal_name: Yup.string().required("Deal Name is required").max(515, "Deal Name should not exceed 515 characters"),
            demand_partners: Yup.string().required("Demand Partner is required").max(80, "Demand Partners should not exceed 80 characters"),
            buyer_id: Yup.string().required("Demand Partner Buyer ID is required").max(128, "Demand Partner Buyer ID should not exceed 128 characters"),
            // advertiser_id: Yup.string().required("Advertiser ID is required").max(255, "Advertiser ID should not exceed 255 characters"),
            // account_id: Yup.string().required("Account ID is required").max(255, "Account ID should not exceed 255 characters"),
            ...campaignDateValidation,
            audience_usage: Yup.string().required("Planned Usage is required"),
            creativeTagIdDropDown: Yup.string().required("Creative Tag ID is required"),
            creativeTagId: Yup.string().required("Creative Tag ID is required"),
        },
        ),
        onSubmit: (values) => {},
    },
};
